<template>
  <div>
    <div class="text-center">
      <button :disabled="loading" @click="createFormOpen=true" type="button" class="mb-8 inline-block px-7 py-3 bg-green-600 text-white font-bold text-sm leading-snug uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out">
        {{loading ? "Please wait..." : "Create Recipe"}}
      </button>
    </div>
  </div>
  <div v-if="loading" class="text-center">
    <h1 class="font-bold text-2xl mb-8">Creating new Recipes...</h1>
  </div>
  <TransitionRoot as="template" :show="createFormOpen">
    <Dialog as="div" class="relative z-10" @close="createFormOpen = false; resetFormData()">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
              <div class="block p-6 rounded-lg shadow-lg bg-white">
                <h2 class="font-bold text-2xl mb-4">🥪 Create Recipes</h2>

                <!--INPUT FORM-->
                <form @submit.prevent=" handleSubmit(); resetFormData(); createFormOpen=false">

                  <div class="form-group mb-6">
                    <label for="exampleInputTitle" class="form-label inline-block mb-2 text-gray-700">Recipes Name</label>
                    <input class="form-control
                                    block
                                    w-full
                                    px-3
                                    py-1.5
                                    text-base
                                    font-normal
                                    text-gray-700
                                    bg-white bg-clip-padding
                                    border border-solid border-gray-300
                                    rounded
                                    transition
                                    ease-in-out
                                    m-0
                                    focus:text-gray-700 focus:bg-white focus:border-green-600 focus:outline-none"
                           id="exampleInputEmail1"
                           v-model="formatData.name" required type="text"
                           aria-describedby="emailHelp" placeholder="Enter Name">
                    <small id="emailHelp" class="block mt-1 text-xs text-gray-600">Name does have to be unique, you have have duplicate name.</small>
                  </div>
                  <div class="mb-3 xl:w-96">
                    <label for="exampleFormControlTextarea1" class="form-label inline-block mb-2 text-gray-700">Instruction</label>
                    <textarea class="form-control
                                        block
                                        w-full
                                        px-3
                                        py-1.5
                                        text-base
                                        font-normal
                                        text-gray-700
                                        bg-white bg-clip-padding
                                        border border-solid border-gray-300
                                        rounded
                                        transition
                                        ease-in-out
                                        m-0
                                        focus:text-gray-700 focus:bg-white focus:border-green-600 focus:outline-none"
                              v-model="formatData.instruction"
                              id="exampleFormControlTextarea1"
                              rows="3"
                              placeholder="Your instruction"
                    ></textarea>
                  </div>
                  <div class="mb-3 xl:w-96">
                    <label for="exampleURL0" class="form-label inline-block mb-2 text-gray-700">Image URL</label>
                    <input class="form-control
                                  block
                                  w-full
                                  px-3
                                  py-1.5
                                  text-base
                                  font-normal
                                  text-gray-700
                                  bg-white bg-clip-padding
                                  border border-solid border-gray-300
                                  rounded
                                  transition
                                  ease-in-out
                                  m-0
                                  focus:text-gray-700 focus:bg-white focus:border-green-600 focus:outline-none"
                           v-model="formatData.image"
                           type="url"
                           id="exampleURL0"
                           placeholder="https://www.example.com/image.jpg"/>

                    <small id="emailHelp" class="mb-8 block mt-1 text-xs text-gray-600">
                      <strong>ExampleURL below</strong>
                      <p>https://img.freepik.com/free-photo/flat-lay-batch-cooking-composition_23-2148765597.jpg?w=2000</p>
                    </small>

                  </div>

                  <button  class="px-6
                                  py-2.5
                                  bg-green-600
                                  text-white
                                  font-bold
                                  text-xs
                                  leading-tight
                                  uppercase
                                  rounded
                                  shadow-md
                                  hover:bg-green-700 hover:shadow-lg
                                  focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0
                                  active:bg-green-800 active:shadow-lg
                                  transition
                                  duration-150
                                  ease-in-out"
                           type="submit">{{ loading ? "Creating..." : "Create"}}
                  </button>

                  <button  class="px-6
                                  ml-2
                                  py-2.5
                                  bg-red-600
                                  text-white
                                  font-bold
                                  text-xs
                                  leading-tight
                                  uppercase
                                  rounded
                                  shadow-md
                                  hover:bg-red-700 hover:shadow-lg
                                  focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0
                                  active:bg-red-800 active:shadow-lg
                                  transition
                                  duration-150
                                  ease-in-out"
                           @click.prevent="createFormOpen = false">Cancel
                  </button>

                </form>
              </div>
              <!--END INPUT FORM-->

            </DialogPanel>
          </TransitionChild>

        </div>
      </div>

    </Dialog>
  </TransitionRoot>
</template>

<script>


import { ref } from 'vue'
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'

import gql from 'graphql-tag'
import { useMutation } from '@vue/apollo-composable'

let createFormOpen = ref(false)

const CREATE_RECIPES = gql`
  mutation CreateRecipe($data: createRecipeInput, $ingredient: [createIngredient!]) {
    createRecipe (data: $data,Ingredient: $ingredient) {
      name
      instruction
      ingredients {
        name
      }
    }
  }
`
export default {
  components:{Dialog, DialogPanel, TransitionChild, TransitionRoot},
  data()
  {
    return {
      formatData:{
        name:"",
        instruction:"",
        image:"",
        ingredients:[]
      },
    }
  },
  methods: {
    resetFormData()
    {
      this.formatData.name = ""
      this.formatData.instruction = ""
      this.formatData.image = ""
    },
    handleSubmit(){
      this.createRecipe({
        data:
            {
              name: this.formatData.name,
              instruction: this.formatData.instruction,
              image:this.formatData.image
            },
        ingredient: []
      })
    }
  },
  setup () {
    const { mutate:createRecipe, loading, error} = useMutation(CREATE_RECIPES)
    return {
      createRecipe,
      loading,
      error,
      createFormOpen
    }

  },
}
</script>

<style scoped>

</style>